import { PropsWithChildren } from 'react'

import { cn } from '@/shared/lib'

import { buttonVariants } from './variants'
import { ButtonVariantsProps } from './variants'

type ButtonProps = PropsWithChildren<
  ButtonVariantsProps & {
    onClick?: () => void
  }
>

export const PageButton = ({
  mode,
  selected,
  onClick,
  children,
}: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        buttonVariants({
          mode,
          disabled: false,
          selected,
        }),
        'relative z-1',
      )}
    >
      {children}
    </button>
  )
}

const BUTTON_SIZE = 26
const BUTTON_GAP = 12

type SelectPageMarkerProps = {
  mode: ButtonVariantsProps['mode']
  selectedIndex: number
}

export const SelectPageMarker = ({
  mode,
  selectedIndex,
}: SelectPageMarkerProps) => {
  const position = selectedIndex * (BUTTON_SIZE + BUTTON_GAP)

  return (
    <div
      className={cn(
        'absolute h-[26px] w-[26px] rounded-full transition-all duration-200 ease-in-out',
        mode === 'light' ? 'bg-white' : 'bg-black',
      )}
      style={{
        left: `${position}px`,
      }}
    />
  )
}
